export const _ADD               = "/fR7lUmRbLvYJlCHuLh7ig==";
export const _EDIT              = "RieRNFb2xQy/Q7JlnRVitg==";
export const _VIEW              = "qyPGFQ0g9d7stsirpM52iA==";
export const _DELETE            = "4l3e5YC7gujpPow0LxFjCA==";
export const _RECOVER           = "qz0fosJ58DOUeL3pnLhvOg==";
export const _LIST              = "+nkLqd9L4hp5WCh7BHhRig==";
export const _TRASH             = "oOPiGEZX9ph03jKWRa+HJQ==";